"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

/**
 * Cookie-баннер с явной кнопкой «Принять».
 *
 * Юридическое обоснование (152-ФЗ + позиция РКН):
 * - cookies, по которым может быть идентифицирован пользователь, относятся
 *   к ПДн → нужно активное согласие на их использование;
 * - запрещены предустановленные галочки и неявное согласие;
 * - на баннере обязательна ссылка на политику обработки ПДн.
 *
 * Решение «Принять» сохраняется в localStorage; до этого момента баннер
 * виден на каждой странице (но не блокирует контент).
 */
const LS_KEY = "stok:cookie-consent";
const VERSION = "1";

export function CookieBanner() {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    try {
      const v = localStorage.getItem(LS_KEY);
      if (v === VERSION) {
        setHidden(true);
      } else {
        setHidden(false);
      }
    } catch {
      setHidden(false);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(LS_KEY, VERSION);
    } catch {}
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <div
      role="region"
      aria-label="Согласие на использование cookies"
      className="fixed inset-x-3 bottom-24 z-40 mx-auto w-auto max-w-[420px] -translate-x-0 rounded-[12px] border border-border bg-white p-3.5 shadow-lg sm:left-1/2 sm:right-auto sm:-translate-x-1/2"
    >
      <p className="mb-3 text-[13px] leading-snug text-text">
        Мы используем cookies для работы сайта и аналитики. Продолжая
        просмотр, вы соглашаетесь с{" "}
        <Link href="/policy" className="text-brand-700 underline hover:no-underline">
          Политикой обработки ПДн
        </Link>
        .
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={accept}
          className="h-9 flex-1 rounded-[8px] bg-brand-600 px-4 text-sm font-medium text-white transition-colors hover:bg-brand-700 active:opacity-80"
        >
          Принять
        </button>
        <Link
          href="/policy"
          className="flex h-9 items-center rounded-[8px] border border-border px-3 text-xs font-medium text-text-muted transition-colors hover:bg-bg-muted hover:text-text"
        >
          Подробнее
        </Link>
      </div>
    </div>
  );
}
